<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="9"
          ><div class="search-area-div" style="width: 102px">工作要求名称</div>
          <el-input v-model="page.paramName" size="mini" class="ipt-sty" placeholder="请输入工作要求"></el-input
        ></el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">新增工作要求</el-button>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="campaignsState"
          label="工作要求"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.paramName }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="更新人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateUserName||'-' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="120px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.row)">编辑 ｜</a>
            <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50 ,100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- 弹窗 -->
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="45%">
      <template v-if="dialogVisible">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item >
          <span slot="label" style="color: red">*</span>
          <span slot="label">工作要求 </span>
          <el-input type="input" :maxlength="30" placeholder="示例：药店拜访的签到要求、药店拜访的拍照要求" v-model="paramName"> </el-input>
          <!-- <div style="color:red;font-size:12px;float:left;">注：名称需包含“打卡”或“签到”文字，移动端才有签到功能</div> -->
        </el-form-item>
        
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label"> 要求说明 </span>
          <el-input type="textarea" :rows="5" :maxlength="200" placeholder="请输入工作要求说明" v-model="reqDesc">
          </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">关联任务</span>
          <el-select
            v-model="reqNote"
            placeholder="请选择关联任务"
            filterable
            multiple
            class="fl"
            style="width: 100%"
          >
              <el-option v-for="item in optionContents" :key="item.guid" :label="item.taskContentName" :value="item.guid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span slot="label">要求示例图 </span>
          <el-upload
            action="#"
            name="image"
            class="fl"
            :limit="1"
            list-type="picture-card"
            :headers="token"
            :file-list="fileList"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :http-request="uploadImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" >
        <el-button size="mini" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="mini"
          type="info"
          v-if="textTitle == '新增工作要求'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="mini"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      contentMainHeight: window.innerHeight - 200,
      height: window.innerHeight - 260,
      fullscreenLoading: false,
      textTitle: '新增工作要求',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        bizType: '工作要求',
        paramName: '',
        tenantGuid:localStorage.guid,
      },
      optionContents:[],
      paramName: '',
      reqNote: '',
      reqDesc: '',
      fileList:[],
 
      right: 'right',
      tableData: [],
      dialogVisible: false,
      

      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
    };
  },
  created() {
    this.getList();
    this.getContentList();
  },
  watch: {},
  methods: {
    search() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        bizType: '工作要求',
        paramName: '',
        reqNote: '',
        reqDesc: '',
        fileList: [],
        optionContents:[],
        tenantGuid:localStorage.guid,
        tenantName: JSON.parse(localStorage.userInfo).tenantName
      };
      this.getList();
    },
    addVersion() {
      this.textTitle = '新增工作要求';
      this.paramName = '';
      this.dialogVisible = true;
      this.reqNote = '';
      this.reqDesc = '';
      this.fileList = [];
    },
    editVersion(detail) {
      this.textTitle = '编辑工作要求';
      this.dialogVisible = true;
      let otherJson = detail.paramValue1 ? JSON.parse(detail.paramValue1) : null;
      this.guid = detail.guid;
      this.paramName = detail.paramName;
      this.reqDesc = detail.paramValue;
      this.reqNote = otherJson && otherJson.reqNote;
      this.fileList = otherJson && otherJson.fileList||[];
      console.log( this.reqNote)
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.paramName) {
        self.$message.error('请输入工作要求名称');
        return;
      }
      if (!this.reqDesc) {
        self.$message.error('请输入要求说明');
        return;
      }
      if (this.reqNote.length==0) {
        self.$message.error('请选择关联任务');
        return;
      }
      
      var req = {
        paramName: this.paramName,
        paramValue: this.reqDesc,
        paramValue1: JSON.stringify({
          fileList: this.fileList,
          reqNote: this.reqNote,
        }),
        bizType: '工作要求',
        tenantGuid:localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.paramName) {
        self.$message.error('请输入工作要求名称');
        return;
      }
      if (!this.reqDesc) {
         self.$message.error('请输入工作要求说明');
        return;
      }
    if (this.reqNote.length==0) {
        self.$message.error('请选择关联任务');
        return;
    }
      var req = {
        bizType: '工作要求',
        paramName: this.paramName,
        guid: this.guid,
        paramValue: this.reqDesc,
        paramValue1: JSON.stringify({
          fileList: this.fileList,
          reqNote: this.reqNote,
        }),
        tenantGuid:localStorage.guid,
        tenantName: JSON.parse(localStorage.userInfo).tenantName
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleRemove(file) {
      let self = this;
      self.fileList = [];
    },
    uploadImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '要求示例图',
              url: res.data.data,
            };
            self.fileList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    getContentList() {
      let self = this;
      let req = {
          pageIndex: 1,
          pageSize: -1,
          totalPage: 0,
          totalRows: 0,
          taskContentName: '',
          tenantGuid: localStorage.guid,
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.optionContents = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>